import React, { useRef } from "react";
import { useEffect, useState } from "react";
import Header from "../../components/Header";
import "./style.css";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import "react-calendar/dist/Calendar.css";
import { useLocation } from "react-router-dom";
import {
  bookAppointmentAPI,
  carenavigatorlist,
  doctorlist,
  fetchslots,
  sendotp,
  verifyotp,
} from "../../shared/apiservices/mainApi";
import {
  dateFormat,
  DateStringFormat,
  getLastDateOfCurrentMonth,
  notify,
} from "../../shared/helper/helper.service";
import OTPModal from "../../components/Modal/OTPModal";
import { Col, Row } from "react-bootstrap";
import AppointmentBooked from "../../components/Modal/AppointmentBooked";
import ErrorModal from "../../components/Modal/ErrorModal";
import CarouselView from "../../components/CarouselView";
import CalendarView from "../../components/CalendarView";
import SlotView from "../../components/SlotView";
import { FacebookPixel, trackGtagEvent } from "../../shared/helper/pixel";

const MemoizedCarousel = React.memo(({ listData, selectedDoctor, onClick }) => (
  <CarouselView
    listData={listData}
    selectedDoctor={selectedDoctor}
    onClick={onClick}
  />
));

const BookAppoiment = () => {
  const location = useLocation();
  const [date, setDate] = useState(new Date());
  const queryParams = new URLSearchParams(location.search);
  const bookingType = queryParams.get("booking_type");
  const phone_number = queryParams.get("phone_number");
  const [showOTPMOdal, setShowOTPMOdal] = useState(true);
  const [bookingLoader, setBookingLoader] = useState(false);
  const [bookedModalShow, setBookedModalShow] = useState(false);
  const [errorModalShow, setErrorModalShow] = useState(false);
  const [otp, setOtp] = useState("");
  const [listData, setListData] = useState([]);
  const [slotList, setSlotList] = useState([]);
  const [medicsId, setMedicsId] = useState("");
  const [selectedSlot, setSelectedSlot] = useState("");
  const [selectedDoctor, setSelectedDoctor] = useState("");
  const [filteredSlot, setFilteredSlot] = useState([]);
  const [bookAppointmentData, setBookAppointmentData] = useState("");
  let gettemp_token = sessionStorage.getItem("temp_token");
  const textToFind = "Chat with Care Specialist";
  // const [timer, setTimer] = useState(30); // 30 seconds countdown
  // const [isResendDisabled, setIsResendDisabled] = useState(true);

  const istextPresent = () => {
    return bookingType?.toLowerCase().includes(textToFind.toLowerCase());
  };

  useEffect(() => {
    if (!bookingType) {
      window.location.replace("https://lumafertility.com/book");
    }
  }, []);

  useEffect(() => {
    if (istextPresent()) {
      fetchcarenavigator();
    } else {
      fetchdoctorlist();
    }
  }, []);

  useEffect(() => {
    if (gettemp_token == phone_number) {
      setShowOTPMOdal(false);
    } else {
      setShowOTPMOdal(true);
    }
  }, [gettemp_token]);

  useEffect(() => {
    if (phone_number) {
      if (gettemp_token != phone_number) {
        handleSendOtp();
      }
    }
  }, []);

  useEffect(() => {
    filterSlotFun(date);
  }, [date, slotList]);

  // useEffect(() => {
  //   let interval = null;

  //   if (isResendDisabled) {
  //     interval = setInterval(() => {
  //       setTimer((prev) => {
  //         if (prev === 1) {
  //           clearInterval(interval);
  //           setIsResendDisabled(false);
  //           return 30; // reset timer for next time
  //         }
  //         return prev - 1;
  //       });
  //     }, 1000);
  //   }

  //   return () => clearInterval(interval);
  // }, [isResendDisabled]);

  const handleSendOtp = async () => {
    if (phone_number == "") {
      notify("Please Enter Phone Number", "error");
      return;
    }
    if (phone_number.length != 10) {
      notify("Please Enter Valid Phone Number", "error");
      return;
    }
    let payload = {
      mobile: phone_number,
    };
    await sendotp(
      payload,
      (status, res) => {
        if (res?.success) {
          notify(res?.body?.message, "success");
        }
      },
      (err) => {
        notify(err?.response?.data?.error, "error");
      }
    );
  };

  const handleOTPVerify = async () => {
    if (otp.length < 4) {
      notify("Please Enter Valid OTP", "error");
      return;
    }

    let payload = {
      mobile: phone_number,
      otp: otp,
    };

    await verifyotp(
      payload,
      async (status, res) => {
        let userDetail = res?.body;
        console.log("userDetail", userDetail)
        sessionStorage.setItem(
          "temp_token",
          phone_number
        );
        notify(res?.body?.message, "success");
        setOtp("");
        setShowOTPMOdal(false);
        // setIsResendDisabled(true);
        // setTimer(30);
        FacebookPixel.trackCustom('personaldetails_page ', {})
        FacebookPixel.trackCustom('Submit Application', {})
        trackGtagEvent('otp_verify', {
          event_category: 'engagement',
          event_label: 'OTP Verify',
        });
      },
      (err) => {
        console.log("err?.response", err);
        notify(err?.response?.data?.error, "error");
        setOtp("");
      }
    );
  };

  const fetchdoctorlist = async () => {
    await doctorlist(
      (status, res) => {
        if (res?.success) {
          let data = res?.body
          data.sort((a, b) => a.order_sequence - b.order_sequence);
          setListData(data);
        }
      },
      (err) => {
        setListData([]);
        console.log(err);
      }
    );
  };

  const fetchcarenavigator = async () => {
    await carenavigatorlist(
      (status, res) => {
        if (res?.success) {
          let filtereddata = res?.body.filter((el) => el.userId === 924)
          setListData(filtereddata);
        }
      },
      (err) => {
        setListData([]);
        console.log(err);
      }
    );
  };

  const fetchappointmentslots = async (medId, slotdate, flag) => {
    const selectedMonthEnd = getLastDateOfCurrentMonth(slotdate);

    let payload = {
      medicsId: medId ? medId : medicsId,
      fromDate: dateFormat(slotdate),
      toDate: dateFormat(selectedMonthEnd),
    };

    await fetchslots(
      payload,
      async (status, res) => {
        if (res?.body?.responseCode == "001") {
          // notify(res?.body?.errorMessage, "error");
          setErrorModalShow(true);
          setSlotList([]);
        } else {
          setSlotList(res?.body?.response?.doctorSlots);
        }
      },
      (err) => {
        setSlotList([]);

        if (!flag) {
          setErrorModalShow(true);
        }
        // notify(err?.response?.data?.msg, "error");
      }
    );
  };

  const getSevenDayRange = (startDate) => {
    let range = [];
    for (let i = 0; i < slotList?.length; i++) {
      if (slotList[i]?.timeSlots.length > 0) {
        let nextDay = new Date(slotList[i]?.date);
        range.push(nextDay.toDateString());
      }
    }
    return range;
  };

  const isActiveDate = (dateToCheck) => {
    const sevenDayRange = getSevenDayRange();
    return sevenDayRange.includes(dateToCheck.toDateString());
  };

  const handleDoctorClick = (medicsId) => {
    setMedicsId(medicsId);
    fetchappointmentslots(medicsId, date);
  };

  // const handleDateChange = (newDate) => {
  //   let previousSelectedDate = date ? date : null;
  //   if (
  //     previousSelectedDate &&
  //     previousSelectedDate.getMonth() + 1 != newDate.getMonth() + 1
  //   ) {
  //     if (medicsId) {
  //       fetchappointmentslots(medicsId, newDate, "calender");
  //     } else {
  //       setErrorModalShow(true);
  //     }
  //   }
  //   setDate(newDate);
  //   setSelectedSlot("");
  //   filterSlotFun(newDate);
  // };

  const handleDateChange = (newDate) => {
    const previousSelectedDate = date || null;
    const today = new Date();

    const isCurrentMonth =
      newDate.getMonth() === today.getMonth() &&
      newDate.getFullYear() === today.getFullYear();

    const isMonthOrYearChanged = previousSelectedDate &&
      (
        previousSelectedDate.getMonth() !== newDate.getMonth() ||
        previousSelectedDate.getFullYear() !== newDate.getFullYear()
      );

    const dateToUse = isCurrentMonth ? today : newDate;

    if (isMonthOrYearChanged) {
      if (medicsId) {
        fetchappointmentslots(medicsId, dateToUse, "calender");
      } else {
        setErrorModalShow(true);
      }
    }

    setDate(newDate);
    setSelectedSlot("");
    filterSlotFun(newDate);
  };

  const filterSlotFun = (date) => {
    let formattedDate = dateFormat(date);
    let slotfilter =
      slotList?.length > 0 &&
      slotList.filter((slot) => slot?.date == formattedDate);
    setFilteredSlot(slotfilter);
  };

  const handleBookAppoiment = async () => {
    const name = queryParams.get("name");
    const email = queryParams.get("email");
    const gender = queryParams.get("gender");
    const dob = queryParams.get("dob");
    const whatapp_notification = queryParams.get("whatapp_notification");

    if (!selectedSlot?.time) {
      notify("Please slect time slot", "error");
      return;
    }

    let payload = {
      mobile: phone_number,
      fullname: name,
      dob: dob,
      email: email,
      gender: gender,
      iswhatsapp: whatapp_notification == "on" ? true : false,
      visitType: istextPresent()
        ? "Chat with Care Specialist"
        : "Book a Doctor Appointment",
      appointmentWith: istextPresent() ? "SPECIALIST" : "DOCTOR",
      appointmentWithUserId:
        selectedDoctor?.doctorid?.toString() ||
        selectedDoctor?.userId?.toString(),
      medicsId: medicsId,
      appointmentDate: dateFormat(date),
      appointmentSlot: selectedSlot?.time,
      appointmentSlotDuration: 45,
      utm_source: queryParams.get("utm_source") || "NA",
      utm_medium: queryParams.get("utm_medium") || "NA",
      utm_campaign: queryParams.get("utm_campaign") || "NA",
      utm_content: queryParams.get("utm_content") || "NA",
      utm_term: queryParams.get("utm_term") || "NA"
    };

    setBookingLoader(true);

    await bookAppointmentAPI(
      payload,
      async (status, res) => {
        setBookAppointmentData(res?.body);
        setBookedModalShow(true);
        setBookingLoader(false);
        FacebookPixel.trackCustom('appointmentdone ', {})
        FacebookPixel.trackCustom('Lead', payload);
        trackGtagEvent('appoiment_booked', {
          event_category: 'engagement',
          event_label: 'Appoiment Booked',
        });
      },
      (err) => {
        setBookingLoader(false);
        setBookAppointmentData([]);
        if (err?.response?.data?.msg) {
          notify(err?.response?.data?.msg, "error");
        }
      }
    );
  };

  return (
    <div>
      <>
        <Header />
        <div className="view-container">
          {/* <div style={{ position: "relative", marginTop:'8%' }} >
            <p className="sub-title">LETS CONNECT</p>
            <h1 className="main-title">Book An Appointment</h1>
          </div> */}
          <div className="appointment-view">
            <div className="doctor-carousel">
              <h2 className="row-title">
                Select {istextPresent() ? "a care specialist" : "a doctor"}
              </h2>
              {/* <CarouselView
                listData={listData}
                selectedDoctor={selectedDoctor}
                onClick={(item) => {
                  setSelectedDoctor(item);
                  if (item?.medicsId) {
                    handleDoctorClick(item?.medicsId);
                  } else {
                    setSlotList([]);
                    setErrorModalShow(true);
                  }
                }}
              /> */}
              <MemoizedCarousel
                listData={listData}
                selectedDoctor={selectedDoctor}
                onClick={(item) => {
                  setSelectedDoctor(item);
                  if (item?.medicsId) {
                    handleDoctorClick(item?.medicsId);
                  } else {
                    setSlotList([]);
                    setErrorModalShow(true);
                  }
                }}
              />
            </div>
            <div style={{marginLeft: -12, marginRight: -12 }}>
              <h2 className="row-title">
                Select a Slot
              </h2>
              <Row className="justify-content-md-center">
                <Col xs lg="6">
                  <CalendarView
                    onChange={handleDateChange}
                    onActiveStartDateChange={(e) => {
                      handleDateChange(e.activeStartDate)
                    }}
                    value={date}
                    minDate={new Date()}
                    tileClassName={({ date }) => {
                      if (isActiveDate(date)) {
                        return "active-day";
                      }
                      return "";
                    }}
                  />
                </Col>
                <Col xs lg="6">
                  <div className="slot-container">
                    <div className="selected-date">
                      <img
                        className="calendar-outline"
                        src={require("../../asstes/images/calendar-outlinewhite.png")}
                      />
                      <p> {DateStringFormat(date)}</p>
                    </div>
                    {slotList?.length > 0 ? (
                      <SlotView
                        selectedDoctor={selectedDoctor}
                        filteredSlot={filteredSlot}
                        selectedSlot={selectedSlot}
                        onClick={(slot) => {
                          if (selectedSlot.time == slot?.time) {
                            setSelectedSlot("");
                          } else {
                            setSelectedSlot(slot);
                          }
                        }}
                      />
                    ) :
                      <p className="note-style">Please select a doctor to see available slots</p>
                    }
                  </div>
                </Col>
              </Row>
              <div className="appoiment-btn-container">
                {!bookingLoader ? (
                  <button
                    className="appoiment-btn flex-box"
                    onClick={() => {
                      handleBookAppoiment();
                    }}
                  >
                    Book Appointment
                  </button>
                ) : (
                  <button className="appoiment-btn flex-box">
                    <i
                      class="fa fa-spinner fa-spin"
                      style={{ marginRight: 8 }}
                    ></i>
                    Loading..
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
        {showOTPMOdal && (
          <OTPModal
            value={otp}
            onChange={setOtp}
            onVerfy={() => {
              handleOTPVerify();
            }}
            handleResend={handleSendOtp}
          />
        )}
        <AppointmentBooked
          show={bookedModalShow}
          handleClose={() => {
            window.location.replace("https://lumafertility.com/");
            setBookedModalShow(false);
            sessionStorage.removeItem("temp_token");
          }}
          data={bookAppointmentData}
          selectedDoctor={selectedDoctor}
        />
        <ErrorModal
          show={errorModalShow}
          txt={istextPresent() ? "care specialist" : "doctor"}
          handleClose={() => {
            setErrorModalShow(false);
          }}
        />
      </>
    </div>
  );
};

export default BookAppoiment;
